import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {DateService} from '../../../services/date/date.service';
import {DinaUppgifterService} from '../../../services/dina-uppgifter.service';
import {Day, Month} from '../../classes/date.class';

@Component({
  selector: 'app-form-date',
  templateUrl: './form-date.component.html',
  styleUrls: []
})
export class FormDateComponent implements OnInit {

  @Input() id = '';
  @Input() label = '';
  @Input() screenReaderText = '';
  @Input() form: UntypedFormGroup;
  @Input() isSubmitted = false;
  @Input() helpTexts = [];

  @ViewChild('helpFieldBtn') helpFieldBtnElement: ElementRef;

  expanded: boolean;

  years = [];
  months: Month[] = [];
  days: Day[] = [];

  oldAr: string;

  get yearControl() {
    return this.form.get('year');
  }

  get monthControl() {
    return this.form.get('month');
  }

  get dayControl() {
    return this.form.get('day');
  }

  constructor(
    private readonly dateService: DateService,
    private readonly dittUnderlagService: DinaUppgifterService
  ) {
  }

  ngOnInit() {
    this.oldAr = this.yearControl.value;

    this.initValues();

    // Vet inte hur man trigga OnInitEventet utan en subscribe. Detta är en provisorisk lösning
    this.dittUnderlagService.edit$.subscribe(() => {
      this.initValues();
    });

    this.yearControl.valueChanges.subscribe((ar: string) => {
      if (this.oldAr !== ar) {
        this.onChangeAr();
        this.oldAr = ar;
      }
    });
  }

  initValues(): void {
    this.disableControls();
    this.initLists();
    this.enableControlsWithValue();
  }

  enableControlsWithValue(): void {
    this.monthControl.enable();

    if (this.monthControl.value) {
      if (this.monthControl.value === '-1') {
        return;
      }
      this.dayControl.enable();
    }
  }

  disableControls(): void {
    this.monthControl.disable();
    this.dayControl.disable();
  }

  initLists(): void {
    this.years = this.dateService.getYears();
    this.months = this.dateService.getMonths(+this.yearControl.value);
    this.days = this.dateService.getDays(this.yearControl.value, +this.monthControl.value);
  }

  onChangeAr(): void {
    this.monthControl.setValue(null);
    this.monthControl.enable();

    this.dayControl.setValue(null);
    this.dayControl.disable();

    this.months = this.dateService.getMonths(+this.yearControl.value);
  }

  onChangeManad(): void {
    this.dayControl.setValue(null);
    if (this.monthControl.value === '-1') {
      this.days = this.dateService.getDays();
      this.dayControl.setValue('-1');
      this.dayControl.disable();
      return;
    }
    this.days = this.dateService.getDays(this.yearControl.value, +this.monthControl.value);
    this.dayControl.enable();
  }

  isInfoTextEmpty(): boolean {
    return this.helpTexts.length === 0;
  }

  onClose(): void {
    this.expanded = false;
    this.helpFieldBtnElement.nativeElement.focus();
  }

  onOpenAlert() {
    this.expanded = this.toggleAlert();
    return false;
  }

  onKeydownEnter(): void {
    this.expanded = this.toggleAlert();
  }

  onKeydownSpace() {
    this.expanded = this.toggleAlert();
    return false; // Stoppar scroll down
  }

  toggleAlert(): boolean {
    this.expanded = !this.expanded;
    return this.expanded;
  }
}
